const submitSheetsForm = async (form, event) => {
    event.preventDefault();
    disableSubmitButton(form[0]);

    if (form.hasClass("sheets-form")) {
        const formData = new FormData(form[0]);
        // UTM tracking
        if (window.sessionStorage.getItem('utmmedium')) {
            const utmParameterNames = [
                'utmmedium',
                'utmsource',
                'utmcampaign',
                'utmcontent',
                'utmkeyword',
            ];
            for (const utmName of utmParameterNames) {
                formData.append(utmName, window.sessionStorage.getItem(utmName))
            }
        }
        try {
            const response = await fetch(form.attr("action"), {
                method: "post",
                body: new URLSearchParams(formData),
            });
            if (!response.ok) {
                throw new Error(`Response status: ${response.status}`);
            }
            const json = await response.json();
            //TODO: Change #thankYouMessage to class
            if (json.status === "google-success") {
                // GTM
                dataLayer.push({'event': 'leadFormSubmitted', 'sheetsFormName': document.getElementsByName('action')[0].value})
                // Facebook
                window.fbq && window.fbq('track', 'Lead')
                // Bing Ads
                window.uetq && window.uetq.push('event', 'Lead', {})
                // Mutiny
                window.mutiny && window.mutiny.client.trackConversion({name: 'Lead'})
                // LinkedIn CAPI (Lead)
                formData.get('Email') && sendLinkedInCapiEvent(19056852, formData.get('Email'))
                // Reddit Ads
                window.rdt && window.rdt('track', 'Lead')
                if (form.hasClass('thank-you-url')) {
                    form[0].innerHTML = document.getElementById('thankYouMessage').innerHTML;
                    return;
                }
                form[0].innerHTML = '<p class="marketo-thank-you">' + form.data('thank-you') + '</p>';
                return;
            }
            if (json.status === "google-success-redirect") {
                window.location = json.location
                return;
            }
            if (json.status === "google-error" || json.status === "exception") {
                jQuery('#thankYouMessage')
                    .html("<p>" + json.message + "</p>")
                    .addClass('visible')
                return;
            }
            if (json.status === 'validation-error') {
                for (const fieldName of json.errors) {
                    const input = jQuery(form[0].querySelector(`[name="${fieldName}"]`));
                    input.addClass("invalid")
                        .removeClass("valid")
                        .parent()
                        .find('p:not(.blacklist)')
                        .addClass("visible");
                    jQuery('input[type=checkbox]')
                        .closest('.checkbox')
                        .find('p.error')
                        .addClass('visible');
                }
                enableSubmitButton(form[0]);
                return;
            }
        }
        catch (error) {
            Sentry && Sentry.captureException(error);
            jQuery('#thankYouMessage')
                .html('<p>An error occurred while processing your request.</p>')
                .addClass('visible')
            return;
        }
    }
    ;
}
